import { Grid } from "@mui/material";
import { ButtonCancel } from "components/buttons";
import { ButtonApplyFilter } from "components/buttons/ButtonApplyFilter";
import { MprcInputStyles } from "components/filter/MprcInputStyles";
import { AutoCompleteDataModel, AutoCompleteSuggestions, MprcAutoComplete } from "components/MprcAutoComplete";
import { createAutoCompleteModel } from "components/MprcAutoComplete/AutoCompleteDataModel";
import { EnrollmentHistoryFilterOptions } from "generated/CoreApi_v1";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { IAdvFilterPickerProps } from "views/general/AdvancedFilter/interfaces";

////////////////////////////////////////////////////////////////////////////

export const EnrollmentHistoryPicker: React.FC<IAdvFilterPickerProps> = (props) => {

    const { filter, onApply, onCancel } = props;
    const { t } = useTranslation("shared");
    const [selected, setSelected] = useState<AutoCompleteDataModel[]>([]);
    const inputRef = useRef<HTMLInputElement>(undefined);
    const multiSelect = filter.canRepeat ?? false;

    const options = useRef<AutoCompleteDataModel[]>([
        createAutoCompleteModel(EnrollmentHistoryFilterOptions.NeverEnroll, t("AdvFilter.Picker.EnrollmentHistory.Options.NeverEnrollText")),
        createAutoCompleteModel(EnrollmentHistoryFilterOptions.NeverApproved, t("AdvFilter.Picker.EnrollmentHistory.Options.NeverApprovedText")),
        createAutoCompleteModel(EnrollmentHistoryFilterOptions.NeverEnrollOrNeverApproved, t("AdvFilter.Picker.EnrollmentHistory.Options.NeverEnrollOrNeverApprovedText")),
        createAutoCompleteModel(EnrollmentHistoryFilterOptions.Approved, t("AdvFilter.Picker.EnrollmentHistory.Options.ApprovedText")),
        createAutoCompleteModel(EnrollmentHistoryFilterOptions.Reproved, t("AdvFilter.Picker.EnrollmentHistory.Options.ReprovedText")),
    ]);

    ////////////////////////////////////////////////////////////////////////////////

    ///
    const getSuggestions = (searchText: string, offset: number, take: number): Promise<AutoCompleteSuggestions<AutoCompleteDataModel>> => {
        return new Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>((resolve) => {
            searchText = searchText.toLowerCase();
            const items = options.current;
            resolve({
                items: items.filter(x => x.label.toLowerCase().includes(searchText)),
                totalRows: items.length
            });
        });
    };

    ///
    const handleApply = () => {
        if (selected.length > 0) {
            const newFilter = selected.map(item => ({
                command: filter!.command,
                optionalGroup: filter?.optionGroup,
                text: `${filter?.displayName.replace("...", "")}: ${item.label}`,
                value: item.key,
                quickFilter: null,
                period: null,
                range: null,
                includeDescendants: null
            }));
            onApply(newFilter, filter);
        }
    };

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return (
        <Grid container alignItems="flex-end" spacing={2} width="100%">
            <Grid size="grow">
                <MprcAutoComplete
                    id="enrollmentHistoryOptionInput"
                    autoFocus
                    label={t("AdvFilter.Picker.EnrollmentHistory.EnrollmentHistoryLabel")}
                    placeholder={t("AdvFilter.Picker.EnrollmentHistory.Placeholder")}
                    multiSelect={multiSelect}
                    maxSuggestionCount={0}
                    selectedItems={selected}
                    onGetSuggestions={getSuggestions}
                    onChange={(items) => setSelected(items)}
                    onApply={handleApply}
                    onCancel={onCancel}
                    sx={MprcInputStyles.filter}
                    inputRef={inputRef}
                />
            </Grid>
            <Grid>
                <ButtonApplyFilter
                    variant="text"
                    disabled={selected.length == 0}
                    onClick={handleApply}
                />
                <ButtonCancel
                    variant="text"
                    onClick={onCancel}
                />
            </Grid>
        </Grid>
    );
};
